const makeLabel = ({text = ''} = {}) => ({
  type: 'label',
  children: [{
    text,
  }],
});

export default makeLabel;
